module.exports = __webpack_public_path__ + "img/client-3.6bc94cee.webp";